import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { Container } from 'react-bootstrap';
import withContentfulTag from '../../utils/withContentfulTag';
import errorGraphic from '../../assets/svg/404-error-page.svg';
import { contentfulPropTypes } from '../../propTypes';
import { LoginCard } from '../../ui';

const StyledContainer = styled(Container)`
  max-width: 652px;
`;

const NotFoundContainer = ({ contentful, loading, fetched }) => {
  return (
    !loading &&
    fetched && (
      <LoginCard>
        <StyledContainer className="text-center pt-4">
          <img src={errorGraphic} alt="404 error page not found" />
          <h1 className="pb-2 pt-3">{contentful?.subtitle}</h1>
          <ReactMarkdown>{contentful?.body}</ReactMarkdown>
        </StyledContainer>
      </LoginCard>
    )
  );
};

NotFoundContainer.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(NotFoundContainer, 'web_app_not_found_page');
